import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthRepository } from '../../domain/repository';
import { AuthRefreshRequest, AuthRefreshResponse } from '../../domain/dto';
import { HttpResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class RefreshTokenUseCase {
  constructor(private authRepository: AuthRepository) {}

  execute(request: AuthRefreshRequest = {}): Observable<HttpResponse<AuthRefreshResponse>> {
    return this.authRepository.refreshToken(request);
  }
}


